import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import { TrendingOnEdxTestData, UseTrendingOnEdx } from "./types";

const CUSTOM_RULE_ID = "trendingOnEdx";

const useTrendingOnEdx: UseTrendingOnEdx = () => {
  const { isLoading, value } = useMonarchRule<{
    data: TrendingOnEdxTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        enableTest: false,
        showCourses: false,
        coursesPosition: 0,
      },
    };
  }

  const variant = value?.data?.enableTest ? "test" : "control";
  // force showCourses to false if coursesPosition is invalid
  const showCourses = ![0, 1].includes(value?.data?.coursesPosition)
    ? false
    : value?.data?.showCourses;

  return {
    isLoading,
    variant,
    data: { ...value?.data, showCourses },
  };
};

export default useTrendingOnEdx;
